import DefaultContainer from '../../container/default_container';
import './index_web.css';
import constants from '../../constants';
import { CountdownTimer, HorizontalScroll, View } from '../../component';
import redirectPage from '../../hoc/redirect';
import MiniGamesConfirmationModal from '../../component/minigame_confirmation_modal';
import { convertToDollars, isSmartPhone } from '../../utilities/helper';
import useTheme from '../../utilities/hooks/theme';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
const PrizesWeb = ({
  gameDetails,
  prizes,
  onPlayGameClick,
  onPressDismiss,
  confirmationModal,
  onConfirmationHandler,
  leaderBoard,
  teamName,
  slideLeft,
  slideRight,
  isGamePlayed,
  tableContainerStyle,
  tableRowStyle2,
  tableRowStyle1,
  tableHeaderStyle,
  rupeeCoinBackDropStyle,
  currentScorePillStyle,
  highScorePillStyle,
  playGameBtnStyle
}: any) => {
  const { contest, gameName, gameImage, gameType, highScore = 0, currentScore = 0 } = gameDetails;

  const { winningsAmount, entryFee } = contest;
  const { MoreTheme: theme } = useTheme();
  const totalPrizePoolStyle = {
    background: theme.minigamesGameWinnningPriceBg,
    boxShadow: theme.minigamesGameWinnningPriceBoxShadow,
    border: `1px solid ${
      gameType === 'playerVsPlayer'
        ? theme.minigamesGameWinningPvpBorder
        : theme.minigamesGameWinningTimerWrapperBorder
    }`
  };
  const entryFeeTimerStyle = {
    background: theme.minigamesGameEntryFeeTimerBg,
    boxShadow: theme.minigamesGameEntryFeeTimerBoxShadow,
    border: `1px solid ${
      gameType === 'playerVsPlayer'
        ? theme.minigamesGameWinningPvpBorder
        : theme.minigamesGameWinningTimerWrapperBorder
    }`
  };

  const prizePoolTimerWrapperStyle = {
    background: theme.minigamesGameWinningTimerWrapperBg,
    boxShadow: theme.minigamesGameWinningTimerWrapperBoxShadow,
    border: `1px solid ${theme.minigamesGameWinningTimerWrapperBorder}`
  };

  const gameInfoContainerStyle = {
    background: theme.minigamesGameInfoContainerBg,
    border: `1px solid ${theme.minigamesGameInfoContainerBorder}`
  };

  const winningsArrowBg = {
    background: theme.gameInfoWinningsArrowBg
  };
  const winningsGuideLeftArrowStyle = {
    borderTop: `1px solid ${theme.gameInfoRuppeCoinBackDropBorder}`,
    borderBottom: `1px solid ${theme.gameInfoRuppeCoinBackDropBorder}`,
    borderLeft: `1px solid ${theme.gameInfoRuppeCoinBackDropBorder}`
  };
  const winningsGuideRightArrowStyle = {
    borderTop: `1px solid ${theme.gameInfoRuppeCoinBackDropBorder}`,
    borderBottom: `1px solid ${theme.gameInfoRuppeCoinBackDropBorder}`,
    borderRight: `1px solid ${theme.gameInfoRuppeCoinBackDropBorder}`
  };

  return (
    <DefaultContainer isWelcomeMessage={false}>
      <div className="gameInfo_wrapper_web">
        <div className="gameInfo_gameDetails_container_web">
          <div className="gameInfo_gameDetails_leftPart_web" style={gameInfoContainerStyle}>
            <img className="gameInfo_game_img_web" src={gameImage} />
            <div className="gameInfo_game_name_prize_container">
              <div className="gameInfo_game_name">
                {gameName}
                <img src={constants.Images.Live} />
              </div>
              <div className="gameInfo_seperator"></div>
              <div className="gameInfo_game_prize_container">
                <div className="gameInfo_game_prize_title">Total Cash Prize</div>
                <div className="gameInfo_game_prize_amount">{`${convertToDollars(
                  winningsAmount / 100
                )}`}</div>
              </div>
            </div>
          </div>
          <div className="gameInfo_gameDetails_rightPart_web" style={prizePoolTimerWrapperStyle}>
            <div className="gameInfo_prize_countdown_wrapper">
              <div className="gameInfo_total_prizePool_wrapper">
                <div className="gameInfo_total_prizePool_title">Total Prize Pool</div>
                <div className="gameInfo_total_prize_container" style={totalPrizePoolStyle}>
                  <img src={constants.Images.Wallet} width="15%" />
                  <p>{`${convertToDollars(winningsAmount / 100)}`}</p>
                </div>
              </div>

              <div className="gameInfo__entryFee__wrapper">
                <div className="gameInfo_counter_title">Entry Fee</div>
                <div className="gameInfo_counter_container" style={entryFeeTimerStyle}>
                  <img src={constants.Images.Wallet} width="23%" />
                  <p>{`${convertToDollars(entryFee)}`}</p>
                </div>
              </div>
              <div className="gameInfo_counter_wrapper ">
                <div className="gameInfo_counter_title">
                  {gameType === 'playerVsPlayer' ? 'Game Type' : 'Ends In'}
                </div>
                <div className="gameInfo_counter_container" style={entryFeeTimerStyle}>
                  {gameType === 'playerVsPlayer' ? (
                    <>
                      <img src={constants.Images.playerVsPlayer} width="60px" />
                      <p> Player VS Player </p>
                    </>
                  ) : (
                    <>
                      <img src={constants.Images.HourGlass} width="30%" />
                      <CountdownTimer
                        style={{
                          fontSize: '22px',
                          fontWeight: '900',
                          color: 'white',
                          paddingLeft: '1%'
                        }}
                        isShowAlert={true}
                        matchItem={gameDetails}
                      />{' '}
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="gameInfo_play_game_container">
              <div className="gameInfo_play_game_label">Join Now And Win Real Cash Prizes</div>
              <button
                className="gameInfo_playgame_btn"
                style={playGameBtnStyle}
                onClick={onPlayGameClick}>
                {isGamePlayed ? 'Play Again' : 'Play Game'}
              </button>
            </div>
          </div>
        </div>
        {isGamePlayed && gameType !== 'playerVsPlayer' && (
          <div className="gameInfo__currentScore__highScore__wrapper__web">
            <div className="gameInfo__currentScore__container__web" style={currentScorePillStyle}>
              <p className="gameInfo__currentScore__highScore__title__web">Your Last Score</p>
              <div className="gameInfoScore__seperator__web"></div>
              <p className="gameInfo__currentScore__highScore__score__web">{currentScore}</p>
            </div>
            <div className="gameInfo__highScore__container__web" style={highScorePillStyle}>
              <p
                className="gameInfo__currentScore__highScore__title__web"
                style={{ marginRight: '5%' }}>
                Your Highest Score
              </p>
              <div className="gameInfoScore__seperator__web"></div>
              <p className="gameInfo__currentScore__highScore__score__web">{highScore}</p>
            </div>
          </div>
        )}
        {gameType !== 'playerVsPlayer' && (
          <div className="gameInfo__leaderBoard__winnings__header__web">
            <div className="gameInfo__winText_desktop">you can win</div>
            <div className="gameInfo__leaderBoard_desktop">Leaderboard</div>
          </div>
        )}
        {gameType !== 'playerVsPlayer' && (
          <div className="gameInfo__leaderBoard__winnings__wrapper__web">
            <View className="gameInfo__winnings__wrapper__web">
              <div className="gameInfo__winPrizeWrapperWeb">
                <div
                  className="gameInfo__leftArrow_web"
                  style={{ ...winningsArrowBg, ...winningsGuideLeftArrowStyle, color: 'white' }}
                  onClick={() => slideLeft('gameInfo__scroll')}>
                  <NavigateBeforeIcon fontSize="large" />
                </div>

                <div className="gameInfo__winPrizeWrapper_desktop" style={rupeeCoinBackDropStyle}>
                  <div className="gameInfo__winPrizeInnerWrapper_desktop">
                    <HorizontalScroll id="gameInfo__scroll">
                      {prizes.map((prize: any, id: number) => {
                        return (
                          <div key={id} className="gameInfo__prizeCard_web">
                            <div
                              className={`gameInfo__rectangle_web
                    ${prize['key'] <= 3 ? 'gameInfo__rectangleTopPrize_web' : ''} 
                    `}>
                              <span className="gameInfo_prizeMoney_web">
                                {prize['type'] == 'rupees' ? prize['value'] / 100 : prize['value']}
                              </span>
                            </div>
                            <span className="gameInfo__Rank_web">{'Rank '}</span>
                            <span className="gameInfo__Rank_web">{prize['key']}</span>
                          </div>
                        );
                      })}
                    </HorizontalScroll>
                  </div>
                </div>
                <div
                  className="gameInfo__rightArrow_web"
                  style={{ ...winningsArrowBg, ...winningsGuideRightArrowStyle, color: 'white' }}
                  onClick={() => slideRight('gameInfo__scroll')}>
                  <NavigateNextIcon fontSize="large" />
                </div>
              </div>
            </View>
            <div
              className={
                isSmartPhone ? 'leaderboard_table_container_mWeb' : 'gameInfo_table_container'
              }
              style={tableContainerStyle}>
              <div className="table_header_container row-center" style={tableHeaderStyle}>
                <div className="gameInfo_table_col1 row-center">Rank</div>
                <div className="gameInfo_table_col2 "> Player</div>
                <div className="gameInfo_table_col3 row-center">Score</div>
                <div className="gameInfo_table_col4 row-center">Can Win</div>
              </div>

              {leaderBoard.map((item: any, idx: any) => (
                <div
                  className={`gameInfo_table_row_container ${
                    item.name == teamName && 'highlighted_table_row'
                  } ${idx === leaderBoard.length - 1 ? 'table_bottom_row' : ''}`}
                  key={idx}
                  style={idx % 2 == 0 ? tableRowStyle1 : tableRowStyle2}>
                  <div className="gameInfo_table_col1 row-center">{item.rank}.</div>
                  <div className="gameInfo_table_col2">{item.name ? item.name : 'you'}</div>
                  <div className="gameInfo_table_col3 row-center">
                    {item.name == teamName ? highScore : item.score}
                  </div>
                  <div className="gameInfo_table_col4 row-center">
                    <img src={constants.Images.coin} />
                    <p>{`${convertToDollars(prizes[item.rank]?.value / 100)}`}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        <MiniGamesConfirmationModal
          visible={confirmationModal}
          onPressDismiss={onPressDismiss}
          onConfirmationHandler={onConfirmationHandler}
          EntryFee={entryFee}
        />
      </div>
    </DefaultContainer>
  );
};

export default redirectPage(PrizesWeb);
